<section class="video-message-dialog">
  <header class="video-message-dialog__header">
    <div>
      <h2>{{ "message.record-video.title" | translate }}</h2>
      <p>{{ "message.record-video.description" | translate }}</p>
    </div>
    <button
      nz-button
      type="button"
      nzShape="circle"
      class="close-button"
      [attr.aria-label]="'message.record-video.close' | translate"
      (click)="onCancel()"
    >
      <span nz-icon nzType="close" nzTheme="outline"></span>
    </button>
  </header>
  <div class="video-message-dialog__content">
    <div class="video-panel">
      <video class="video-panel__preview" [class.video-panel__preview--visible]="isRecording || blobUrl" controls #videoElement></video>
      <div *ngIf="!isRecording && !blobUrl" class="video-panel__empty-state">
        <span nz-icon nzType="video-camera" nzTheme="outline" class="video-panel__empty-icon"></span>
        <h3>{{ (cameraUnavailable ? "message.record-video.camera-permission-blocked" : "message.record-video.ready-to-record") | translate }}</h3>
        <p>{{ (cameraUnavailable ? "message.record-video.camera-access-help" : "message.record-video.camera-instruction") | translate }}</p>
        <button *ngIf="cameraUnavailable" nz-button nzType="primary" type="button" (click)="startVideoRecording()">
          {{ "message.record-video.try-again" | translate }}
        </button>
        <button
          *ngIf="!cameraUnavailable"
          nz-button
          type="button"
          nzShape="circle"
          class="record-button"
          [attr.aria-label]="'message.record-video.start-recording' | translate"
          (click)="startVideoRecording()"
        >
          <span></span>
        </button>
      </div>
      <span *ngIf="isRecording" class="video-panel__badge">{{ "message.record-video.recording" | translate }}</span>
      <span *ngIf="blobUrl" class="video-panel__badge">{{ "message.record-video.preview" | translate }}</span>
      <div class="video-panel__controls" [class.video-panel__controls--visible]="isRecording">
        <span *ngIf="isRecording && !recordingLoading" class="timer"><i></i>{{ recordedTime }}</span>
        <button
          [nzLoading]="recordingLoading"
          nz-button
          type="button"
          nzShape="circle"
          class="stop-recording-button"
          [attr.aria-label]="'message.record-video.stop-recording' | translate"
          (click)="stopVideoRecording()"
        >
          <span *ngIf="!recordingLoading"></span>
        </button>
      </div>
    </div>
    <aside class="video-message-dialog__aside">
      <div>
        <h3>{{ "message.record-video.section-title" | translate }}</h3>
        <p>{{ "message.record-video.section-description" | translate }}</p>
      </div>
      <div class="info-card">
        <h4>{{ "message.record-video.privacy-title" | translate }}</h4>
        <p>{{ "message.record-video.privacy-description" | translate }}</p>
      </div>
      <div class="info-card">
        <h4>{{ "message.record-video.status-title" | translate }}</h4>
        <p>{{ recordingStatus }}</p>
      </div>
    </aside>
  </div>
  <footer *ngIf="blobUrl" class="video-message-dialog__footer">
    <button nz-button type="button" (click)="retakeVideo()">
      <span nz-icon nzType="sync" nzTheme="outline"></span>
      {{ "message.record-video.retake" | translate }}
    </button>
    <button nz-button nzType="primary" type="button" (click)="onSubmit()">
      {{ "message.record-video.send" | translate }}
      <span nz-icon nzType="send" nzTheme="outline"></span>
    </button>
  </footer>
</section>
